// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import AnimValueProgress from "../../../../engines/components/animation/AnimValueProgress";
import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import BaseStatePlusSprite from "../../../../engines/components/state/BaseStatePlusSprite";
import { UIScrollSelect } from "../../../../engines/components/UIScrollSelect";
import O1HD, { managers } from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { TaskKind } from "../../../define/TaskKind";
import ModelDialogLayer from "../../../gameCommon/basic/ModelDialogLayer";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { BoastGuiFeiConfig } from "./BoastGuiFeiConfig";

const {ccclass, property} = cc._decorator;

const c_max_good = 1000;
const c_add_good = 200;
const c_price = 100000;
const c_end_award_goods = 10054;
@ccclass
export default class BoastGuiFeiLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeSelectText: cc.Node = null;
	@property({ type: cc.Node, displayName:'' })
	nodeHintAd: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeLose: cc.Node = null;

    @property(cc.Button)
    btnConfirm: cc.Button = null;

    @property({ type: cc.Node, displayName:'' })
    sprTalkAnswer: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
    sprBg2: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
    sprBg1: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelGuiFei: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
    sprGuiFeiTalk: cc.Node = null;

	@property({ type: AnimValueProgress, displayName:'' })
	progressGood: AnimValueProgress = null;

	@property({ type: BaseStatePlusSprite, displayName:'' })
    sprGuiFei: BaseStatePlusSprite = null;

	@property({ type: cc.Node, displayName:'' })
	nodeStep1: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeStep2: cc.Node = null;

    @property({ type: [UIScrollSelect], displayName: "答案选择节点" })
    scrollNode: UIScrollSelect[] = [];

    @property({ type: [cc.Node], displayName: "答案节点" })
    answerNode: cc.Node[] = [];

    @property({type:cc.Label})
    labelAnswer:cc.Label = null;
    @property({type:cc.Label})
    labelGood:cc.Label = null;

    /** 好感度 */
    private cGoodVibes = 0;

    private choose1: number = 0
    private choose2: number = 0
    private choose3: number = 0
    /** 当前阶段 */
    private curStage = 0;

    private curState = 0;

    private bGameStart = false;

    // LIFE-CYCLE CALLBACKS: 

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        this.sprBg2.active = false;
        this.sprBg1.active = true;
        this.nodeStep1.active = false;
        this.nodeStep2.active = false;
        this.sprGuiFeiTalk.active = false;
        this.nodeLose.active = false;

        this.refreshHintState();
        O1HD.on(MessageEventKind.EventName.BOAST_GUI_FEI_HINT, this.refreshHintState, this);
        this.refreshProgress(0, c_max_good, false);
    }

    startStep1() {
        this.curState = 1;
        this.showGuiFeiChat('你来了，正好本宫无聊，咱们玩个游戏吧');
        this.scheduleOnce(()=> {
            this.nodeStep1.active = true;
        }, 1);
    }

    startStep2() {
        this.curState = 3;
        this.bGameStart = true;
        cc.tween(this.sprGuiFeiTalk).to(0.2,{scale:0}).start();
        this.sprBg2.active = true;
        this.sprBg1.active = false;
        this.sprTalkAnswer.active = false;
        this.nodeStep2.active = true;
        this.nodeSelectText.active = false;
        this.nodeSelectText.opacity = 0;

        this.curStage = 0;
        this.startStage();
    }

    async startStage() {
        let info = BoastGuiFeiConfig[this.curStage];
        this.showGuiFeiChat(info.quiz);

        await this.delayTime(0.8);
        if (!this.node || !cc.isValid(this.node)) {
            return;
        }

        this.nodeSelectText.active = true;
        cc.tween(this.nodeSelectText)
        .to(0.5, {opacity: 255})
        .start();


        for (let i = 0; i < this.scrollNode.length; i++) {
            let textList = info.select[i];
            let aNode = this.answerNode[i];
            for (let j = 0; j < textList.length; j++) {
                let node = aNode.parent.children[j]
                if (!node) {
                    node = cc.instantiate(aNode)
                    node.parent = aNode.parent
                    node.setPosition(aNode.position)
                }
                node.getComponent(cc.Label).string = textList[j];
            }
            this.scrollNode[i].scrollTo(0, false);
        }
    }

    refreshProgress(
        curV: number
        , totalV: number
        , bPalyAni: boolean = false
    ) {
        this.labelGood.string = curV + '/' + totalV;
        let progressValue = Math.min(curV / totalV, 1);
        this.progressGood.setValue(progressValue, true, bPalyAni);
    }
    
    onEventChoose1(eventData: { target: UIScrollSelect, touch: boolean, index: number }) {
        if (!eventData.touch) return
        this.choose1 = eventData.index;
        managers().soundMgr.playVibrate();
        managers().soundMgr.playSound('clickWord', null, BUNDLE_SMALL_NAME.boastGuiFei); // 点击音效

        // cc.log('--- 1', this.choose1);
    }
    
    onEventChoose2(eventData: { target: UIScrollSelect, touch: boolean, index: number }) {
        if (!eventData.touch) return
        this.choose2 = eventData.index;
        managers().soundMgr.playVibrate();
        managers().soundMgr.playSound('clickWord', null, BUNDLE_SMALL_NAME.boastGuiFei); // 点击音效

        // cc.log('--- 2', this.choose2);
    }
    
    onEventChoose3(eventData: { target: UIScrollSelect, touch: boolean, index: number }) {
        if (!eventData.touch) return
        this.choose3 = eventData.index;
        managers().soundMgr.playVibrate();
        managers().soundMgr.playSound('clickWord', null, BUNDLE_SMALL_NAME.boastGuiFei); // 点击音效

        // cc.log('--- 3', this.choose3);
    }

    showGuiFeiChat(chat:string){
        this.sprGuiFeiTalk.active = true;
        this.sprGuiFeiTalk.scale = 0;
        this.labelGuiFei.string = chat;
        cc.tween(this.sprGuiFeiTalk).to(0.2,{scale:1}).start();
    }
    
    showSelfChat(chat: string) {
        this.sprTalkAnswer.active = true;
        this.sprTalkAnswer.scale = 0;
        this.labelAnswer.string = chat;
        cc.tween(this.sprTalkAnswer).to(0.2,{scale:1}).start();
    }

    showGuiFeiState(bCorrect: boolean) {
        this.sprGuiFei.setFill(bCorrect ? 1 : 2);

        let soundName = 'lose';
        if (bCorrect) {
            soundName = 'win';
        } 
        O1HD.getManagers().soundMgr.playSound(soundName, null, BUNDLE_SMALL_NAME.boastGuiFei);
    }

    async onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let price = c_price;
        if ( O1HD.getServices().userSrv.getCoins() < price) {
            O1HD.getModules().uiControlModule.showMessageBox("你的金额不足");
            NormalGameManager._instance.openBankPage();
            return;
        }

        this.btnConfirm.interactable = false;
        
        let info = BoastGuiFeiConfig[this.curStage];
        let bCorrect = false;
        let strText = info.incorrect;
        if (info.correctAnswer[0] == this.choose1 
            && info.correctAnswer[1] == this.choose2
            && info.correctAnswer[2] == this.choose3
        ) {
            strText = info.correct;
            bCorrect = true;
        }
        let strAnswer = info.select[0][this.choose1] + info.select[1][this.choose2] + info.select[2][this.choose3];
        this.showSelfChat(strAnswer);

        await this.delayTime(1);
        if (!this.node || !cc.isValid(this.node)) {
            return;
        }
        this.showGuiFeiChat(strText);

        await this.delayTime(1);
        if (!this.node || !cc.isValid(this.node)) {
            return;
        }
        this.showGuiFeiState(bCorrect);

        if (!bCorrect) {
            O1HD.getServices().userSrv.setCoins( -c_price, true);
            this.sprGuiFei.node.active = false;
            this.nodeLose.active = true;
        }
        await this.delayTime(1);
        if (!this.node || !cc.isValid(this.node)) {
            return;
        }
        this.nodeLose.active = false;
        this.sprGuiFei.node.active = true;
        this.sprGuiFei.setFill(0);
        this.btnConfirm.interactable = true;
        this.sprTalkAnswer.active = false;
        this.sprGuiFeiTalk.active = false;

        if (bCorrect) {
            this.cGoodVibes += c_add_good;
            this.refreshProgress(this.cGoodVibes, c_max_good, true);
            this.curStage++;
            if (this.curStage >= BoastGuiFeiConfig.length) {
                // 胜利
                let addGoodsList = {};
                addGoodsList[c_end_award_goods] = 1;
                await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
                utilsModel.onPushGoods(c_end_award_goods, 1);

                let gameData = NormalGameManager._instance.getGameData();
                gameData.bFinishBoastGuiFei = true;
                NormalGameManager._instance.writeGameData();
                
                NormalGameManager._instance.taskDataManage.addNewFinishTask(TaskKind.TaskId.TASK_6);

                O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);

                this.closeLayer();
            } else {
                this.startStage();
                this.choose1 = 0;
                this.choose2 = 0;
                this.choose3 = 0;
            }
        } else {
            this.showGuiFeiChat(info.quiz);
        }
    }

    async delayTime(time: number) {
        return new Promise<void> ((resolve)=> {
            this.scheduleOnce(()=> {
                resolve();
            }, time);
        });
    }

    refreshHintState() {
        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.boastGuiFeiAdCount >= 1) {
            this.nodeHintAd.active = false;
        } else {
            this.nodeHintAd.active = true;
        }
    }

    onClickEextStep() {
        if (this.curState == 0) {
            this.startStep1();
        } else if(this.curState == 2) {
            this.unschedule(this.startStep2);
            this.startStep2();
        }  
    }

    onClickReject() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeLayer();
    }

    onClickAgree() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.nodeStep1.active = false;
        this.showGuiFeiChat('你夸夸我，夸的好有奖励，夸得不好罚10万，开始咯');
        this.curState = 2;
        this.scheduleOnce(this.startStep2, 3.5);
    }

    openHint() {
        utilsView.openPopupLayer('prefab/BoastGuiFeiHint', BUNDLE_SMALL_NAME.boastGuiFei);
    }

    onClickHint() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.boastGuiFeiAdCount >= 1) {
            this.openHint();
            return;
        }
        utilsModel.loadAndShowVideoAdTrans(()=>{
            let gameData = NormalGameManager._instance.getGameData();
            gameData.boastGuiFeiAdCount++;
            NormalGameManager._instance.writeGameData();
            this.openHint();
            this.refreshHintState();
        },()=>{
 
        }, null, "夸贵妃看广告获得提示");
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        if (this.bGameStart) {
            ModelDialogLayer.show(' 确认要退出吗？', null, ()=> {
                this.closeLayer();
            }
            , '确认退出'
            , '我再试试'
            );
        } else {
            this.closeLayer();
        }
    }

    closeLayer() {
        this.node.destroy();
        this._carryData.parent.destroyNode();
    }

    // update (dt) {}
}
